import { useQuery } from "@tanstack/react-query";

import { getWoodTypesOptions } from "../../generated/client/octalog-service/@tanstack/react-query.gen";

export const useGetWoodTypes = () => {
  return useQuery({
    ...getWoodTypesOptions(),
  });
};
